export default __webpack_public_path__ + "static/media/Confectionery4.522c917e.png";